module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-Ultra.6fe65cb.ttf";